import { usePrefetchPendingExperiences } from "@src/api/experiences/use-prefetch-pending-experiences";

export const usePrefetchPendingExperiments = async () => {
  void usePrefetchPendingExperiences("experiment");
};
